import { render, staticRenderFns } from "./FreightNotPaidByClientMainSection.vue?vue&type=template&id=dbf4ed28"
import script from "./FreightNotPaidByClientMainSection.vue?vue&type=script&lang=js"
export * from "./FreightNotPaidByClientMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports